<template>
  <div class="app-calendar border">
    <!-- <b-button
      size="sm"
      class="btn-icon btn-close"
      variant="flat-primary"
      @click="$emit('close')"
    >
      <feather-icon icon="XIcon" title="Cancelar" />
    </b-button> -->
    <div class="row no-gutters">
      <!-- Sidebar -->
      <!-- <div
        class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
        :class="{ show: isCalendarOverlaySidebarActive }"
      >
        <calendar-sidebar
          :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive"
        />
      </div> -->

      <!-- Calendar -->
      <div class="col position-relative">
        <div class="card shadow-none border-0 mb-0 rounded-0">
          <div class="card-body pb-0 calendar-custom">
            <b-overlay
              variant="gray"
              :show="displayOverlay"
              spinner-variant="primary"
              blur="0"
              opacity=".75"
              rounded="sm"
            >
              <full-calendar
                ref="refCalendar"
                :options="calendarOptions"
                class="full-calendar "
              />
            </b-overlay>
          </div>
        </div>
      </div>

      <!-- Sidebar Overlay -->
      <div
        class="body-content-overlay"
        :class="{ show: isCalendarOverlaySidebarActive }"
        @click="isCalendarOverlaySidebarActive = false"
      />
      <!-- <calendar-event-handler
        v-model="isEventHandlerSidebarActive"
        :event="event"
        :isEventHandlerSidebarImport="isEventHandlerSidebarImport"
        :clear-event-data="clearEventData"
        @remove-event="removeEvent"
        @add-event="addEvent"
        @update-event="updateEvent"
        @import-event="importEvents"
      /> -->

      <!-- <calendar-event-detail
        v-model="isEventHandlerSidebarActive"
        :newsViewData="currentNewsDetail"
      /> -->
    </div>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';

import store from "../../../store/store";
import { onUnmounted, computed } from "@vue/composition-api";
import calendarStoreModule from "./calendarStoreModule";
import CalendarSidebar from "./calendar-sidebar/CalendarSidebar.vue";
// import CalendarEventHandler from "./calendar-event-handler/CalendarEventHandler.vue";
import useCalendar from "./useCalendar";
import AppConstants from '@/appConstants';
import { BButton, BOverlay } from "bootstrap-vue";
// import CalendarEventDetail from './calendar-event-detail/CalendarEventDetail.vue';
import ptLocale from "@fullcalendar/core/locales/pt-br";
import { CONTENT } from '../../../enums/enum-content';
import convertDatetimeHelper from '../../../helpers/convert-datetime-helper';
import reportService from '../../../providers/reportService';
import esLocale from "@fullcalendar/core/locales/es";
import { getLocaleCode } from "../../../helpers/locale-helper";
import { getColorFromNews } from '@core/utils/utils'

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    CalendarSidebar,
    BButton,
    // CalendarEventDetail,
    BOverlay,
  },
  props: {
    selectedFilter: {
    type: Object,
    default: () => ({
      characteristic: [],
      periodicity: [],
      country: [],
      content: [],
      subject: [],
      topic: [],
      users: null,
      reportType: null,
    }),
  },

  },
  created() {
    
  },
  computed: {
    currentCommodity() {
      return this.$store.state.currentCommodity;
    },
    currentCalendar() {
      return this.$refs.refCalendar;
    },
    getLocale() {
      const locale = this.$i18n.locale;
      const code = getLocaleCode(locale);
      switch (code) {
        case 1:
          return ptLocale;
        case 2:
          return undefined;
        case 3:
          return esLocale;
        case 4:
          return esLocale;
        case 5:
          return ptLocale;
        default:
          return ptLocale;
      }
    },
    calendarOptions() {
      // plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
      return {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
        initialView: 'dayGridMonth',
        // slotEventOverlap: false, // Evita a sobreposição dos eventos
        locale: this.getLocale,
        headerToolbar: {
          start: 'sidebarToggle, prev, next, title',
          end: 'dayGridMonth,timeGridWeek,timeGridDay',
          // end: 'dayGridMonth,timeGridWeek,timeGridDay,list',
        },
        eventDisplay: 'block',
        events: this.fetchData,

        // text buttons
        buttonText: {
          // prev: 'Anterior',
          // next: 'Próximo',
          // prevYear: 'Ano anterior',
          // nextYear: 'Próximo ano',
          today: this.$t('SCHEDULE').Today,
          month: this.$t('SCHEDULE').Month,
          week: this.$t('SCHEDULE').Week,
          day: this.$t('SCHEDULE').Day,
          list: this.$t('SCHEDULE').List,
        },

        // titleFormat: { // will produce something like "Tuesday, September 18, 2018"
        //   month: 'numeric',
        //   year: 'numeric',
        //   day: 'numeric'
        // },
        // eventTimeFormat: {
        //   hour: "2-digit",
        //   minute: "2-digit",
        //   meridiem: false,
        // },

        /*
          Enable dragging and resizing event
          ? Docs: https://fullcalendar.io/docs/editable
        */
        editable: false,

        /*
          Enable resizing event from start
          ? Docs: https://fullcalendar.io/docs/eventResizableFromStart
        */
        eventResizableFromStart: true,

        /*
          Automatically scroll the scroll-containers during event drag-and-drop and date selecting
          ? Docs: https://fullcalendar.io/docs/dragScroll
        */
        dragScroll: false,

        /*
          Max number of events within a given day
          ? Docs: https://fullcalendar.io/docs/dayMaxEvents
        */
        dayMaxEvents: 4,

        /*
          Determines if day names and week names are clickable
          ? Docs: https://fullcalendar.io/docs/navLinks
        */
        navLinks: true,

        eventClassNames({ event: calendarEvent }) {
          // console.log('[eventClassNames] ', calendarEvent);
          // if (calendarEvent._def.extendedProps.newsData.newsContent[0].color_origin[0]) {
          //   const color = calendarEvent._def.extendedProps.newsData.newsContent[0].color_origin[0].color;
          //   if (color) {
          //     calendarEvent.backgroundColor = color;
          //   }
          // }
          /* eslint-disable */
          return ['bg-light-primary'];
        },
        eventClick: this.openDetail,
        customButtons: {
          sidebarToggle: {
            // --- This dummy text actual icon rendering is handled using SCSS ----- //
            text: 'sidebar',
            click() {
              /* eslint-disable */
              isCalendarOverlaySidebarActive = !isCalendarOverlaySidebarActive;
            },
          },
        },

        dateClick(info) {},

        /*
          Handle event drop (Also include dragged event)
          ? Docs: https://fullcalendar.io/docs/eventDrop
          ? We can use `eventDragStop` but it doesn't return updated event so we have to use `eventDrop` which returns updated event
        */
        eventDrop({ event: droppedEvent }) {
          // updateEvent(grabEventDataFromEventApi(droppedEvent))
        },

        /*
          Handle event resize
          ? Docs: https://fullcalendar.io/docs/eventResize
        */
        eventResize({ event: resizedEvent }) {
          // updateEvent(grabEventDataFromEventApi(resizedEvent))
        },

        // Get direction from app state (store)
        rerenderDelay: 350,
        eventTimeFormat: { 
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false,
        },
      };
    }
  },
  methods: {
    reloadDataWithFilters(filters) {
      this.filters = filters;
      this.currentCalendar.getApi().refetchEvents();
    },
    reloadDataEvents(searchQuery = '') {
      this.searchQuery = searchQuery;
      this.currentCalendar.getApi().refetchEvents();
      // change date
      // const calendarApi = this.currentCalendar.getApi();
      // console.log('[reloadDataEvents]', calendarApi);
      // calendarApi.gotoDate(new Date('2024-03-01'));
    },
    fetchData(info, successCallback) {
      if (!info) return
      console.log('[fetchData]');
      this.displayOverlay = true;
      const params = new URLSearchParams();
      params.append("fromDate", convertDatetimeHelper.convertDateToStringFormatFrom(info.startStr));
      params.append("toDate", convertDatetimeHelper.convertDateToStringFormatFrom(info.endStr));
      
      // params.append('contentList', `${CONTENT.CONSULTING_COURSES},${CONTENT.CONSULTING_SPEECHES}`);
      params.append("page", 1);
      params.append("limit", 100);

      // params.append("commodity", this.currentCommodity.id);
      if (this.selectedFilter.content) {
        if (this.selectedFilter.content.length > 0) {
          params.append("contentList", this.selectedFilter.content.map(item => item.id).join(','));
        }
      }
      if (this.selectedFilter.subject) {
        if (this.selectedFilter.subject.length > 0) {
          params.append("subjectList", this.selectedFilter.subject.map(item => item.id).join(','));
        }
      }
      if (this.selectedFilter.country) {
        if (this.selectedFilter.country.length > 0) {
          params.append("country", this.selectedFilter.country.map(item => item.id).join(','));
        }
      }
      if (this.selectedFilter.disclosureAnnouncement) {
        params.append("disclosureAnnouncement", true);
      }
      if (this.selectedFilter.disclosureInvite) {
        params.append("disclosureInvite", true);
      }
      params.append("commodity", 0);
      params.append("calendar", true);
      if (this.searchQuery) {
        params.append("searchQuery", this.searchQuery);
      }
      reportService.getAllReportsByCommodity(params)
      .then(response => {
        this.displayOverlay = false;
        const dataResp = response.data.map(item => {
          // console.log(`[news-color][${item.content.title.data}]`, item.newsContent[0].color_origin[0] ? item.newsContent[0].color_origin[0].color : '')
          const color = getColorFromNews(item);
          
          return {
            //TODO
            // The dateFrom and dateTo are reversed because it is wrong in the backend.
            title: item.content.title.data,
            end: item.eventScheduleDuration_dateFrom,
            start: item.eventScheduleDuration_dateTo,
            allDay: false,
            url: '',
            extendedProps: {
              location: '',
              description: '',
            },
            newsData: item,
            color: color
          }
        });
        this.displayOverlay = false;
        successCallback(dataResp)
      })
      .catch(error => {
        this.displayOverlay = false;
        console.log(error);
      });
    },
    openDetail({ event: clickedEvent }) {
      const newsData = JSON.parse(JSON.stringify(clickedEvent._def.extendedProps.newsData));
      this.$emit('open-detail', newsData);
    }
  },
  data() {
    return {
      displayOverlay: false,
      isCalendarOverlaySidebarActive: false,
      isEventHandlerSidebarActive: false,
      searchQuery: '',
      filters: {},
    }
    
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
.row {
    display: flex;
    flex-wrap: wrap;
}
.no-gutters {
    margin-right: 0;
    margin-left: 0;
}
.col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
}
.fc .fc-toolbar .fc-button-group .fc-button-primary:not(.fc-prev-button):not(.fc-next-button).fc-button-active, .fc .fc-toolbar .fc-button-group .fc-button-primary:not(.fc-prev-button):not(.fc-next-button):hover {
  // background-color: rgb(194, 211, 157) !important;
  border-color: #4d5762 ;
  color: #000 !important;
}
.theme-dark .fc .fc-toolbar .fc-button-group .fc-button-primary:not(.fc-prev-button):not(.fc-next-button) {
    border-color: #6c757d ;
    color: #efefef ;
}
button.fc-sidebarToggle-button.fc-button.fc-button-primary {
    display: none;
}
.card-body.pb-0.calendar-custom {
    // margin-bottom: 20px;
}
.theme-dark .fc .fc-toolbar .fc-prev-button .fc-icon, .fc .fc-toolbar .fc-next-button .fc-icon {
    color: #FFF;
}
.theme-dark .border {
    border: 1px solid #282e34 !important
}
.theme-dark .app-calendar .fc-scrollgrid {
    border-color: #43515e;
}
.theme-dark .fc tbody td, .fc thead th {
    border-color: #43515e;
    color: #FFF;
}
.fc .fc-toolbar .fc-button-group .fc-button-primary:not(.fc-prev-button):not(.fc-next-button).fc-button-active, .fc .fc-toolbar .fc-button-group .fc-button-primary:not(.fc-prev-button):not(.fc-next-button):hover {
    background-color: #28a745 !important;
    color: #fff ! IMPORTANT;
    border-color: #28a745;
}
.fc-event-title.fc-sticky {
    color: #fff;
    padding: 2px;
}
.fc-event-time {
    color: #FFF;
    padding-left: 2px;
    padding-right: 4px;
}
.theme-dark .fc .fc-list {
    border-color: #2f363d;
}
.theme-dark .fc .fc-list-empty {
    background-color: #22292f;
}
.theme-dark .fc-timegrid-slot-label-cushion.fc-scrollgrid-shrink-cushion{
  color: #FFF !important;
}
.theme-dark .fc .fc-toolbar .fc-button-group .fc-button-primary:not(.fc-prev-button):not(.fc-next-button).fc-button-active, .fc .fc-toolbar .fc-button-group .fc-button-primary:not(.fc-prev-button):not(.fc-next-button):hover {
    background-color:#6c757d  ;
    border-color: #6c757d  ;
    color: #FFF !important;
}
.theme-dark.fc .fc-toolbar .fc-button-group .fc-button-primary:not(.fc-prev-button):not(.fc-next-button){
  color: #FFF !important;
}
.theme-dark .fc .fc-day-today {
    background: #fff !important;
    background-color: #4d5762 !important;
}
.theme-dark .theme-dark .app-calendar .fc-day-past .fc-daygrid-day-number, .theme-dark .app-calendar .fc-day-future .fc-daygrid-day-number {
    color: #ddd !important;
}
</style>
